import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
const asRecord = (value)=>typeof value === 'object' && value != null ? value : {};
export const readPersistedLocationState = (io)=>asRecord(asRecord(io.getHistoryState()).state);
export const persistLocationState = (io, patch)=>{
    io.replaceHistoryState(_object_spread_props(_object_spread({}, asRecord(io.getHistoryState())), {
        state: _object_spread({}, readPersistedLocationState(io), patch)
    }));
};
